<template>
    <nav class="navbar navbar-expand-lg fixed-top navbar-dark bg-primary">
        <div class="navbar-header mr-auto">
            <router-link
                :to="{name: 'dossiers'}"
                class="navbar-brand"
            >
                CRM Inelys
            </router-link>
        </div>

        <ul class="nav navbar-nav">
            <li class="nav-item">
                <transition name="fade">
                    <div v-if="$store.state.auth.checked">
                        <div
                            v-if="$store.state.auth.user"
                            class="d-inline-block mr-4 h5 text-white"
                        >
                            <i class="fas fa-user-alt mr-1" />
                            {{ $store.state.auth.user.prenom }}
                            {{ $store.state.auth.user.nom }}
                        </div>

                        <div
                            class="nav-link cursor-pointer d-inline-block"
                            title="Se déconnecter"
                            @click="logout"
                        >
                            <i class="fa fa-power-off btn-disconnect" />
                        </div>
                    </div>
                </transition>
            </li>
        </ul>
    </nav>
</template>

<script>
    export default {
        name: "TheHeader",

        data: function() {
            return {}
        },

        methods: {
            /**
             * Déconnecte l'utilisateur
             */
            logout: function () {
                this.$store.commit('saveLogout')

                axios.get('/auth/logout')
                    .then(() => this.$notify('success', "Vous avez bien été déconnecté."))
                    .catch(() => {
                        this.$store.commit('saveLogin')
                        this.$notify('danger', "Vous n'avez pas pu être déconnecté correctement.")
                        this.$router.push({name: 'dossiers'})
                    })

                this.$router.push({name: 'login'})
            }
        }
    }
</script>

<style lang="scss" scoped>
    .nav-link {
        transition: .25s;

        &:hover {
            color: #fff !important;
        }
    }
</style>
